import React, { useRef, useState } from 'react'
import Button from '../../Button/Button'
import Popover from '../../Popover/Popover'
import ViewAllChoicesPopover from './ViewAllChoicesPopover'
import { Choice } from './selectFieldHelpers'

interface ViewAllChoicesTriggerProps {
  fieldUid: string
  choices: Choice[]
  isKeyValue: boolean
  isMultiple: boolean
  currentValue: string | string[] | null
  isReadOnly?: boolean
  title?: string
  onApply: (newValue: string | string[] | null) => void
}

/**
 * The "View All ({N}) Choices" link + its popover, shared by RADIO and CHECKBOX inline
 * lists once the choice count exceeds the inline limit. Owns the open/anchor state so the
 * callers only supply data and the apply handler.
 */
const ViewAllChoicesTrigger: React.FC<ViewAllChoicesTriggerProps> = ({
  fieldUid,
  choices,
  isKeyValue,
  isMultiple,
  currentValue,
  isReadOnly,
  title,
  onApply
}) => {
  const [open, setOpen] = useState(false)
  const btnRef = useRef<HTMLButtonElement>(null)

  return (
    <>
      <Button
        version="v2"
        buttonType="tertiary"
        size="small"
        buttonRef={btnRef}
        disabled={isReadOnly}
        onClick={() => setOpen(true)}
        testId={`cs-asset-details-field-${fieldUid}-view-all`}
      >
        {`View All (${choices.length}) Choices`}
      </Button>
      <Popover isOpen={open} onClose={() => setOpen(false)} anchorRef={btnRef} popoverWidth={400}>
        <ViewAllChoicesPopover
          choices={choices}
          isKeyValue={isKeyValue}
          isMultiple={isMultiple}
          currentValue={currentValue}
          title={title}
          onApply={onApply}
          onClose={() => setOpen(false)}
          testId={`cs-asset-details-field-${fieldUid}-view-all-popover`}
        />
      </Popover>
    </>
  )
}

export default ViewAllChoicesTrigger
